import React from 'react'

const Building = ({ width = 22, height = 24 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 22 24"
  >
    <path
      fill="#b18935"
      fillRule="evenodd"
      d="M21,22h2v2H1V22H3V0H21ZM11,19H9v4h2Zm4,0H13v4h2ZM19,2H5V22H7V17H17v5h2ZM7,13H9v2H7Zm4,0h2v2H11Zm4,0h2v2H15ZM7,10H9v2H7Zm4,0h2v2H11Zm4,0h2v2H15ZM7,7H9V9H7Zm4,0h2V9H11Zm4,0h2V9H15ZM7,4H9V6H7Zm4,0h2V6H11Zm4,0h2V6H15Z"
      transform="translate(-1)"
    />
  </svg>
)

export default Building
